import {
  straps,
} from 'mocks/store/data';

const getAvailableStrapSerials = () => straps;

export default getAvailableStrapSerials;
